module.exports = __webpack_public_path__ + "img/pan_right.84cb2b69.svg";